import faucet from '../resources/images/faucet.svg';
import fireAlarm from '../resources/images/fire_alarm.svg';
import extinguisher from '../resources/images/fire_extinguisher.svg';
import kitchenFan from '../resources/images/kitchen_fan.svg';
import pipeLeak from '../resources/images/pipe_leak.svg';
import waterHeater from '../resources/images/water_heater.svg';
import water from '../resources/images/water2.svg';
import { CheckListItems } from '../types';
import { Step } from '../types/enums';

export const checkList: CheckListItems = {
  [Step.FAUCET]: {
    texts: 'housing.check.faucet',
    link: {
      href:
        'https://www.gjensidige.no/godtforberedt/content/vet-du-hvor-stoppekranen-er',
      text: 'Les mer om stoppekran'
    },
    imageSrc: faucet,
    next: Step.WATER_HEATER,
    back: null
  },
  [Step.WATER_HEATER]: {
    texts: 'housing.check.waterHeater',
    imageSrc: waterHeater,
    next: Step.WATER_WASTEWATER,
    back: Step.FAUCET
  },
  [Step.WATER_WASTEWATER]: {
    texts: 'housing.check.waterAndWasteWater',
    link: {
      href:
        'https://www.gjensidige.no/godtforberedt/content/disse-rorene-bor-du-undersoke-ekstra-noye',
      text: 'Disse rørene bør du undersøke ekstra nøye'
    },
    imageSrc: pipeLeak,
    next: Step.DRAINS,
    back: Step.WATER_HEATER
  },
  [Step.DRAINS]: {
    texts: 'housing.check.drains',
    imageSrc: water,
    next: Step.SMOKE_DETECTORS,
    back: Step.WATER_WASTEWATER
  },
  [Step.SMOKE_DETECTORS]: {
    texts: 'housing.check.smokeDetectors',
    imageSrc: fireAlarm,
    next: Step.FIRE_EQUIPMENT,
    back: Step.DRAINS
  },
  [Step.FIRE_EQUIPMENT]: {
    texts: 'housing.check.fireEquipment',
    link: {
      href:
        'https://www.gjensidige.no/godtforberedt/content/slik-slukker-du-brannen-pa-egenhand',
      text: 'Slik slukker du brann'
    },
    imageSrc: extinguisher,
    next: Step.KITCHEN_FAN,
    back: Step.SMOKE_DETECTORS
  },
  [Step.KITCHEN_FAN]: {
    texts: 'housing.check.kitchenFan',
    link: {
      href:
        'https://www.gjensidige.no/godtforberedt/content/kunne-forhindret-halvparten-av-boligbrannene-i-norge1',
      text: 'Kunne forhindret halvparten av boligbrannene i Norge'
    },
    imageSrc: kitchenFan,
    back: Step.FIRE_EQUIPMENT,
    next: null
  }
};
